interface LoginScreenProps {
  onLogin: () => void;
}

export default function LoginScreen({ onLogin }: LoginScreenProps) {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <img
            src="/favicon.png"
            alt="Proteus"
            className="w-16 h-16 mx-auto mb-4"
          />
          <h1 className="text-2xl font-bold text-white mb-2">Proteus</h1>
          <p className="text-zinc-500 text-sm">
            Connect your wallet to access the admin panel
          </p>
        </div>

        <button
          onClick={onLogin}
          className="w-full py-3 px-4 bg-white hover:bg-zinc-100 text-black font-medium rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
        >
          Connect Wallet
        </button>

        <p className="text-center text-zinc-600 text-xs mt-6">
          Only authorized administrators can access this panel.
          <br />
          Your wallet address will be verified against the admin list.
        </p>
      </div>
    </div>
  );
}
